import type { JobFiltersFetchParams } from "@js/apps/common/components/filters";

type PrepareJobsRequestFiltersArg = {
  filters: Partial<JobFiltersFetchParams>;
  isBestMatchAvailable: boolean;
};

export const prepareJobsRequestFilters = ({
  filters,
  isBestMatchAvailable,
}: PrepareJobsRequestFiltersArg) => {
  const filtersCopy: Partial<JobFiltersFetchParams> = { ...filters };

  if (filtersCopy.ordering !== "-score") {
    return filtersCopy;
  }

  if (filtersCopy.search) {
    // With a search phrase "Best match" orders by search relevance
    filtersCopy.ordering = "-search_score";
    return filtersCopy;
  }

  if (!isBestMatchAvailable) {
    // "Best match" may come from query params (e.g. a saved search) when it is not available - use the default ordering
    delete filtersCopy.ordering;
  }

  return filtersCopy;
};
